module.exports = __webpack_public_path__ + "static/media/silver_shield_icon.cbbc82da.svg";